/**
 * src/firebase.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Single Firebase initialization for the entire app.
 * All files that need Firebase import from here — never call initializeApp again.
 *
 * Exports:
 *   app      — Firebase App instance
 *   auth     — Firebase Auth instance
 *   db       — Firestore instance  ← new in Phase 3
 *   analytics — Firebase Analytics (prod only)
 */

import { initializeApp } from 'firebase/app';
import { getAuth }       from 'firebase/auth';
import { getFirestore }  from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            "AIzaSyA7KyJlICxMPKPqaXWIRmvCFz0oYHSa-bM",
  authDomain:        "chart2video.firebaseapp.com",
  projectId:         "chart2video",
  storageBucket:     "chart2video.firebasestorage.app",
  messagingSenderId: "59912451095",
  appId:             "1:59912451095:web:c0b7fc0ce4d9432d439852",
  measurementId:     "G-TT18H1HVBP",
};

export const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);

// Analytics only loads in production (isSupported returns false in Node/SSR)
export const analytics = await isSupported().then(yes => yes ? getAnalytics(app) : null).catch(() => null);